var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donwload-buttom",on:{"click":_vm.handleDownload}},[_c('img',{attrs:{"src":require("@/assets/image/app-store.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }